export const environment = {
  production: true,
  apiUrl: 'api.argos.trixlog.com',
  protocol: 'https://'
};



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/environments/environment.ts